import {useTranslation} from '@aboutyou/i18n';
import {useHistory} from '@aboutyou/router';
import {InfoPopup as RefreshInfo} from '@aboutyou/ui-components';
import React, {FC} from 'react';

export const CampaignRefreshPopup: FC<{
  campaignId?: string;
  onClose: VoidFunction;
}> = ({campaignId, onClose}) => {
  const {t} = useTranslation();
  const history = useHistory();

  const onReload = () => {
    const nextSearch = new URLSearchParams(history.location.search);
    nextSearch.set('invalidateCampaign', campaignId || Date.now().toString());

    window.scrollTo({top: 0, left: 0});
    window.location.href = `${
      history.location.pathname
    }?${nextSearch.toString()}`;
  };

  return (
    <RefreshInfo
      type={'refresh'}
      headline={t('Update available')}
      subline={t(
        'Our assortment and prices have just been been updated. Please click "Refresh" in order to see our latest offerings',
      )}
      showCloseIcon
      onClose={() => onClose()}
      onCtaClick={() => onReload()}
      ctaLabel={t('Refresh')}
      dataTestId={'campaignRefreshInfo'}
    />
  );
};
